export default __webpack_public_path__ + "austin_process_path_to_activities.477f87af.csv";